const radii = {
  button: '20px',
  light: '4px',
  1.5: '0.375rem',
  2.5: '0.625rem',
};

export default radii;
